// extracted by mini-css-extract-plugin
module.exports = {"img":"Image_img__VNXHO"};